import {ApiClient} from '@hconnect/apiclient'
import {AppInsightsAdapter} from '@hconnect/common/logging'
import {AuthProvider} from '@hconnect/login'
import {UpmPlantsProvider} from '@hconnect/upm'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'
import {createRoot} from 'react-dom/client'
import {ErrorBoundary} from 'react-error-boundary'

import './index.css'
import {Router} from './router'
import {RootErrorFallback} from './shared/containers/MaintainErrorFallback'
import {initLocalization} from './shared/localization'
import {AppProviders} from './shared/providers/AppProviders'

AppInsightsAdapter.init()
AppInsightsAdapter.allowTracking()

void initLocalization('default')

const queryClient = new QueryClient()
const rootElement = document.getElementById('root')
const root = createRoot(rootElement as HTMLElement)

root.render(
  <QueryClientProvider client={queryClient}>
    <UpmPlantsProvider api={ApiClient.axiosInstance}>
      <AuthProvider>
        <ErrorBoundary FallbackComponent={RootErrorFallback}>
          <AppProviders>
            <Router />
            <ReactQueryDevtools initialIsOpen={false} />
          </AppProviders>
        </ErrorBoundary>
      </AuthProvider>
    </UpmPlantsProvider>
  </QueryClientProvider>
)
